/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {stopLoading, startLoadding} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  GlobalSettingData: [],
}

export const UpdateGlobalSetting: any = createAsyncThunk(
  'updateGlobalsetting',
  async (data, thunkApi) => {
    const response = await axios.post(`${API_URL}admin/updateGlobalSetting`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetGlobalSetting())
    response?.data?.status
      ? toast?.success(response?.data?.message)
      : toast?.error(response?.data?.message)
    return response.data
  }
)
export const GetGlobalSetting: any = createAsyncThunk(
  'GetGlobalsetting',
  async (data, thunkApi) => {
    const response = await axios.get(`${API_URL}admin/getGlobalSetting`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

const GlobalSettingSlice = createSlice({
  name: 'GlobalSettingSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(GetGlobalSetting.fulfilled, (state, action) => {
      return {...state, GlobalSettingData: action?.payload}
    })
  },
})

export const getGlobalSetting = (state: any) =>
  state?.GlobalSettingSlice?.GlobalSettingData?.data?.[0]?.value
export default GlobalSettingSlice.reducer
